import axios, { API_URL } from './BaseService';

const ORDERS_URL = `${API_URL}/orders/`;
const { STOP_TYPES, LIMIT_TYPES } = require('./ExchangeService');

export async function getOrders(symbol, page = 1, isFuture = false) {
    const ordersUrl = `${ORDERS_URL}${symbol}?page=${page}&isFuture=${isFuture}`;
    const response = await axios.get(ordersUrl);
    return response.data;//{count, rows}
}

export async function cancelOrder(symbol, orderId, isFuture = false) {
    const response = await axios.delete(`${ORDERS_URL}${symbol}/${orderId}?isFuture=${isFuture}`);
    return response.data;
}

export async function syncOrder(beholderOrderId, isFuture = false) {
    const response = await axios.post(`${ORDERS_URL}${beholderOrderId}/sync?isFuture=${isFuture}`, null);
    return response.data;
}

export async function placeOrder(order, isFuture = false) {
    // Se a ordem já tem a estrutura correta (com options), usa diretamente
    let postOrder;
    
    if (order.options) {
        // Já está no formato correto
        postOrder = {
            symbol: order.symbol.toUpperCase(),
            side: order.side.toUpperCase(),
            options: {
                type: order.options.type.toUpperCase()
            }
        };

        // MARKET buy por valor em quote (USDT/USDC) — não enviar quantity
        const quoteOrderQty = order.options.quoteOrderQty != null
            ? parseFloat(order.options.quoteOrderQty)
            : NaN;
        if (Number.isFinite(quoteOrderQty) && quoteOrderQty > 0) {
            postOrder.options.quoteOrderQty = quoteOrderQty;
            postOrder.quantity = null;
        } else if (order.quantity !== null && order.quantity !== undefined && order.quantity !== '') {
            const qty = parseFloat(order.quantity);
            if (!Number.isFinite(qty) || qty <= 0)
                throw new Error('Quantidade inválida para a ordem');
            postOrder.quantity = qty;
        }
        
        // Adiciona limitPrice se fornecido (pode ser null para MARKET)
        if (order.limitPrice !== undefined && order.limitPrice !== null) {
            postOrder.limitPrice = parseFloat(order.limitPrice);
        }
    } else {
        // Formato antigo - converte
        postOrder = {
            symbol: order.symbol.toUpperCase(),
            quantity: parseFloat(order.quantity),
            side: order.side.toUpperCase(),
            options: {
                type: order.type.toUpperCase()
            }
        };

        if (postOrder.options.type === 'MARKET' && order.isQuote) {
            postOrder.options.quoteOrderQty = parseFloat(order.quantity);
            delete postOrder.quantity;
        }

        if ([...LIMIT_TYPES, 'TRAILING_STOP'].includes(postOrder.options.type)) {
            if (order.limitPrice !== undefined && order.limitPrice !== null) {
                postOrder.limitPrice = parseFloat(order.limitPrice);
            }
        }
    }

    if (STOP_TYPES.includes(postOrder.options.type) && order.stopPrice) {
        postOrder.options.stopPrice = parseFloat(order.stopPrice);
    }

    if (postOrder.options.type === 'TRAILING_STOP')//trailing stop de spot
        postOrder.options.stopPriceMultiplier = order.stopPriceMultiplier;

    if (postOrder.options.type === 'TRAILING_STOP_MARKET') {//trailing stop de futuros
        postOrder.options.activationPrice = order.activationPrice;
        postOrder.options.callbackRate = order.callbackRate;
    }

    if (order.reduceOnly)
        postOrder.options.reduceOnly = order.reduceOnly;

    console.log('OrdersService - Enviando ordem para backend:', JSON.stringify(postOrder, null, 2));
    
    try {
        const response = await axios.post(`${ORDERS_URL}?isFuture=${isFuture}`, postOrder);
        return response.data;
    } catch (err) {
        console.error('Erro ao enviar ordem:', err);
        console.error('Status:', err.response?.status);
        console.error('Resposta do erro:', err.response?.data);
        console.error('Mensagem completa:', err.response?.data?.message || err.response?.data?.msg || err.response?.data || err.message);
        
        // Cria um erro mais descritivo
        const errorMessage = err.response?.data?.message || 
                            err.response?.data?.msg || 
                            (typeof err.response?.data === 'string' ? err.response.data : JSON.stringify(err.response?.data)) ||
                            err.message ||
                            'Erro desconhecido ao criar ordem';
        
        const enhancedError = new Error(errorMessage);
        enhancedError.response = err.response;
        enhancedError.status = err.response?.status;
        throw enhancedError;
    }
}

function thirtyDaysAgo() {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    date.setHours(0, 0, 0, 0);
    return date.getTime();
}

function getStartToday() {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    return date.getTime();
}

function getToday() {
    const date = new Date();
    date.setHours(23, 59, 59, 999);
    return date.getTime();
}

export async function getOrdersReport(symbol, startDate, endDate, isFuture = false) {
    startDate = startDate ? startDate.getTime() : thirtyDaysAgo();
    endDate = endDate ? endDate.getTime() : getToday();

    const reportUrl = `${ORDERS_URL}reports/${symbol}?startDate=${startDate}&endDate=${endDate}&isFuture=${isFuture}`;
    const response = await axios.get(reportUrl);
    return response.data;
}

export async function getDayTradeReport(symbol, date, isFuture = false) {
    date = date ? date.getTime() : getStartToday();

    const reportUrl = `${ORDERS_URL}reports/${symbol}?date=${date}&isFuture=${isFuture}`;
    const response = await axios.get(reportUrl);
    return response.data;
}
